<template>
  <div>
    <el-dialog
      class="agent-chat-dialog"
      v-if="isMobile"
      :visible="visible"
      @close="onClose"
    >
      <agent-chat 
        :is-mobile="true" 
        :policy-number="policyNumber"
        :claim-number="claimNumber"
        :claim-id="claimId"
        @on-close="onClose" 
         />
    </el-dialog>
    <transition name="sidebar">
      <aside v-if="!isMobile && visible" class="agent-chat-aside">
        <div class="agent-chat-aside__inner">
          <agent-chat 
          :is-mobile="false" 
          :policy-number="policyNumber"
          :claim-number="claimNumber"
          :claim-id="claimId"
          @on-close="onClose" 
          />
        </div>
      </aside>
    </transition>
  </div>
</template>

<script>
import AgentChat from './agent-chat.vue'
import { mapActions } from 'vuex'

export default {
  name: 'adaptable-agent-chat',
  components: {
    AgentChat
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    policyNumber: {
      type: String,
      default: '',
    },
    claimNumber: {
      type: String,
      default: '',
    },
    claimId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      isMobile: window.innerWidth < 768,
    }
  },
  methods: {
    ...mapActions('policies', {reloadPolicies: 'reload'}),
    onClose () {
      this.reloadPolicies()
      this.$emit('close')
    },
    checkIfMobile () {
      this.isMobile = window.innerWidth < 768
    }
  },
  mounted () {
    window.addEventListener('resize', this.checkIfMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkIfMobile)
  }
}
</script>

<style scoped lang="scss">
.agent-chat-aside {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2000;
  width: 30vw;
  max-width: 100vw;
  height: 100vh;
  background: #fff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.agent-chat-aside__inner {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Sidebar open/close transitions */
.sidebar-enter-active,
.sidebar-leave-active {
  transition: transform 0.3s ease, opacity 0.25s ease;
}

.sidebar-enter,
.sidebar-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.sidebar-enter-to,
.sidebar-leave {
  transform: translateX(0);
  opacity: 1;
}
</style>
<style lang="scss">
.agent-chat-dialog {
  .el-dialog {
    padding: 0;
    margin: auto;
    max-width: 95vw;
    height: 80vh;
    border-radius: 16px;
    overflow: hidden;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    height: 100%;
    width: 100%;
  }
}
</style>
